module.exports = __webpack_public_path__ + "static/media/GCCLOGORED.8fa988fe.webp";